import React, { createContext, useContext, useEffect, useState } from "react";

const UiLayoutContext = createContext(null);

const STORAGE_KEY = "smarttable_layout_mode_v1";
const VALID = ["desktop", "tablet", "smartphone"];

export const UiLayoutProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return VALID.includes(saved) ? saved : "desktop";
        } catch {
            return "desktop";
        }
    });

    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) { /* ignore */ }
        document.documentElement.setAttribute("data-layout-mode", mode);
    }, [mode]);

    const updateMode = (next) => {
        if (!VALID.includes(next)) return;
        setMode(next);
    };

    return (
        <UiLayoutContext.Provider value={{ mode, setMode: updateMode }}>
            {children}
        </UiLayoutContext.Provider>
    );
};

export const useUiLayout = () => useContext(UiLayoutContext) || { mode: "desktop", setMode: () => {} };
